import * as React from 'react';

const Es16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#B5002A", d: "M1 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" }), /* @__PURE__ */ React.createElement("path", { fill: "#F4C327", d: "M1 5.5h14v5H1z" }), /* @__PURE__ */ React.createElement("path", { fill: "#F4F4F4", d: "M6.267 7.124h.408v1.86h-.408z" }), /* @__PURE__ */ React.createElement("path", { fill: "#C60B1E", d: "M5.755 7.736h1.021v.204H5.755zm1.021.817-.612-.205v-.204l.612.204z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#F4F4F4",
    d: "M4.122 7.124a.204.204 0 0 0-.204.204v1.327c0 .248.232.714 1.02.714.789 0 1.02-.466 1.02-.714V7.328a.204.204 0 0 0-.204-.204z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#C60B1E",
    d: "M4.94 8.144H3.918v-.817c0-.113.091-.204.204-.204h.817v1.02Zm0 0h1.02v.51a.51.51 0 0 1-1.02 0z"
  }
), /* @__PURE__ */ React.createElement("path", { fill: "#CF995A", d: "M3.919 8.144h1.02v.51a.51.51 0 0 1-1.02 0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#F4F4F4", d: "M3.204 7.124h.408v1.86h-.408z" }), /* @__PURE__ */ React.createElement("path", { fill: "#334B9E", d: "M3 9.165h.776v.194H3zm3.062 0h.775v.194h-.775z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#CF995A",
    d: "M4.622 6.592a.3.3 0 0 0 .317-.056.31.31 0 0 0 .316.056.307.307 0 0 0 .603-.08.307.307 0 0 0-.42-.285.307.307 0 0 0-.5-.15.306.306 0 0 0-.5.15.305.305 0 0 0-.417.284.306.306 0 0 0 .601.08Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#C60B1E",
    d: "m4.327 6.92-.205-.205.12-.12a.985.985 0 0 1 1.394 0l.12.12-.205.204H4.327Zm-1.224.816h1.02v.204h-1.02zm0 .817.612-.205v-.204l-.612.204z"
  }
), /* @__PURE__ */ React.createElement("circle", { cx: 4.939, cy: 8.187, r: 0.388, fill: "#334B9E" }), /* @__PURE__ */ React.createElement("circle", { cx: 3.403, cy: 6.791, r: 0.194, fill: "#C60B1E" }), /* @__PURE__ */ React.createElement("circle", { cx: 6.49, cy: 6.791, r: 0.194, fill: "#C60B1E" }));
Es16.Size = 16;
Es16.Title = "Es";

export { Es16 as default };
